import {connect} from 'react-redux'
import SidebarReports from 'components/SidebarReports'
import {salesPageRequest,
  changeDateSalesSummary,
  changeOutletSalesSummary,
  exportSummary
} from 'actions/reports/sales'
import {currencyFormatter} from 'utils/formatter'
import {csvName} from 'utils/formatterCsvName'
import moment from 'moment'
import {formValueSelector} from 'redux-form'
import ActionBar from '../ActionBar'
import styles from './ReportSummary.css'
import LoadingSpinner from 'components/LoadingSpinner'
import {browserHistory} from 'react-router'
import * as mpReportSummary from 'mixpanel/reports/summary'

class ReportSummary extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    if (!expired) {
      this.props.dispatch(salesPageRequest())
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  constructor (props) {
    super(props)
    this.state = {
      openSidebar: false
    }
  }

  render () {
    let {showLoadingSpinnerReport} = this.props.data.reports.sales
    return (
      <div id='reports-sales-summary' className={styles.wrapper}>
        <ActionBar onChangeDate={this._onChangeDate} onChangeOutlet={this._onChangeOutlet} onExport={this._onClickExport} />
        <div className='mk-report-sales full-height'>
          <div className='row full-height'>
            <SidebarReports elementClass='visible-lg visible-md slideMenuWeb' location={this.props.location} />
            <SidebarReports elementClass={'visible-xs visible-sm slideMenuMobile ' + (this.state.openSidebar ? 'slideMenuMobileSlide' : '')} onToggle={this._toogleSidebar} location={this.props.location} />
            <div className='col-xs-12 col-sm-12 col-md-9 col-lg-9 report-right-menu full-height'>
              <div className='mk-report-sales-content full-height'>
                <div className='mk-burger-box visible-xs visible-sm'>
                  <div className='mk-burger'>
                    <button type='button' className='navbar-toggle collapsed navbar-burger' onClick={this._showSidebar} data-toggle='collapse' >
                      <span className='sr-only'>Toggle navigation</span>
                      <span className='icon-bar' />
                      <span className='icon-bar' />
                      <span className='icon-bar' />
                    </button>
                  </div>
                </div>
                <div className={`${styles['table-wrapper-responsive']} visible-xs visible-sm`}>
                  <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
                  {showLoadingSpinnerReport !== undefined && !showLoadingSpinnerReport && this._renderTable()}
                </div>
                <div className={`${styles['table-wrapper']} visible-md visible-lg`}>
                  <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
                  {this._renderTable()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _onChangeOutlet = (outletIds = []) => {
    let {startDate, endDate} = this.props.search.date
    mpReportSummary.reportSummaryChangeFilter({outletIds: outletIds, startDate, endDate})
    this.props.dispatch(changeOutletSalesSummary({outletIds, startDate, endDate}))
  }

  _showSidebar = () => {
    this.setState({openSidebar: !this.state.openSidebar})
  }

  _toogleSidebar = () => {
    this.setState({openSidebar: !this.state.openSidebar})
  }

  _onChangeDate = ({startDate, endDate}) => {
    const {outlet} = this.props.search
    let outletIds = outlet
    mpReportSummary.reportSummaryChangeFilter({outletIds: outlet, startDate, endDate})
    this.props.dispatch(changeDateSalesSummary(startDate.toDate(), endDate.toDate(), outletIds))
  }

  _onClickExport = () => {
    let {startDate, endDate} = this.props.search.date
    const outlet = this.props.search.outlet
    const outlets = this.props.outlets

    let filename = csvName(startDate, endDate, 'Report Sales Summary', outlet, outlets)
    mpReportSummary.summaryExport({outletIds: outlet, startDate, endDate})
    let query = {
      startDate: moment(startDate).format('YYYY-MM-DD 00:00:00'),
      endDate: moment(endDate).format('YYYY-MM-DD 23:59:59'),
      outletIds: outlet,
      timeZone: ''
    }
    this.props.dispatch(exportSummary(query, filename))
  }

  _renderTable = () => {
    const {sales} = this.props.data.reports.sales
    return <table className='table table-responsive mk-table-summary'>
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Gross Sales</td>
          <td className='text-right text-unimportant'>
            {currencyFormatter(sales.gross_sales)}
          </td>
        </tr>
        <tr>
          <td>Discounts</td>
          <td className='text-right text-unimportant'>
            {currencyFormatter(-(sales.discounts + sales.redemptions))}
          </td>
        </tr>
        <tr>
          <td>Refunds</td>
          <td className='text-right text-unimportant'>
          ({currencyFormatter(sales.refunds)})
        </td>
        </tr>
        <tr className='divider'>
          <td><strong>Net Sales</strong></td>
          <td className='text-right'>
            <strong>{currencyFormatter(sales.net_sales)}</strong>
          </td>
        </tr>
        <tr>
          <td>Gratuity</td>
          <td className='text-right text-unimportant'>
            {currencyFormatter(sales.gratuity)}
          </td>
        </tr>
        <tr>
          <td>Tax</td>
          <td className='text-right text-unimportant'>
            {currencyFormatter(sales.tax)}
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr className='text-total'>
          <td><strong>Total Collected</strong></td>
          <td className='text-right'>
            <strong>{currencyFormatter(sales.total_collected)}</strong>
          </td>
        </tr>
      </tfoot>
    </table>
  }
}

const selector = formValueSelector('search')

function select (state) {
  return {
    outlets: state.actionBar.outlets,
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        sales: state.reports.sales
      },
      subscriptionExpired: state.subscriptionExpired
    }
  }
}
export default connect(select)(ReportSummary)



// WEBPACK FOOTER //
// ./app/pages/Reports/Sales/ReportSummary/ReportSummary.js